import { sity, rubrics, gearboxes, engines } from 'shared/modules/subjectiveText/allText';
import { getSeoDataByParams } from 'shared/helpers/seoTextFinder';
import FIRST_RUBRICS_TYPES from 'shared/constants/json/firstSeoRubricsTypes.json';
import SECOND_RUBRICS_TYPES from 'shared/constants/json/secondSeoRubricsTypes.json';
import {
  replaceToUpperCase,
  replaceTransport,
  buildInGenitiveCityHeader,
  buildDriveValue,
  replaceToLowerCase,
} from 'shared/modules';

export const buildFirmsSeoDescription = (data, t) => {
  const { cityTitle, section, regLocation, location } = data;
  // if (section === 'СТО') {
  //   if (isRegion)
  //     return t(
  //       'Каталог СТО {locationAccusative}, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто  ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //       { locationAccusative },
  //     );
  //   else if (cityTitle)
  //     return t(
  //       'Каталог СТО в {cityTitle}, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто  ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //       { cityTitle },
  //     );
  //   return t(
  //     'Каталог СТО, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто  ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //   );
  // }
  // if (section && cityDescriptions) {
  //   return t(
  //     '{section} в {cityDescriptions}: Полный список организаций ✅ Адреса ✅ Контактные данные {section} в {cityDescriptions}',
  //     data,
  //   );
  // }
  // if (section) {
  //   return t(
  //     '{section} в Украине: Полный список организаций ✅ Адреса ✅ Контактные данные {section} в вашем городе',
  //     data,
  //   );
  // }
  // if (cityDescriptions) {
  //   return t(
  //     'Каталог СТО в {cityDescriptions}, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //     data,
  //   );
  // }

  if (section === 'СТО' && cityTitle) {
    return t(
      'Каталог СТО {cityTitle} с адресами компаний, телефонами и картой проезда. Связаться с автосервисом и записаться на СТО можно на Автобазаре',
      {
        ...data,
        cityTitle: t(regLocation) || t(location),
      },
    );
  }

  if ((section === 'Авторазборка' || section === 'Авторозборка') && cityTitle) {
    return t(
      'Авторазборка {cityTitle}. Каталог компаний по разбору авто. Адреса, телефоны, карта проезда на сайте Автобазар',
      {
        ...data,
        cityTitle: t(regLocation) || t(location),
      },
    );
  }

  if ((section === 'Автовыкуп' || section === 'Автовикуп') && cityTitle) {
    return t(
      'Автовыкуп {cityTitle}. Каталог компаний по выкупу авто с адресами, телефонами и картой проезда на Автобазаре',
      {
        ...data,
        cityTitle: t(regLocation) || t(location),
      },
    );
  }

  if ((section === 'Запчасти' || section === 'Запчастини') && cityTitle) {
    return t(
      'Дилеры по продаже автозапчастей {cityTitle}. Адреса, телефоны компаний на Автобазаре',
      {
        ...data,
        cityTitle: t(regLocation) || t(location),
      },
    );
  }

  if ((section === 'Автотовары' || section === 'Автотовари') && cityTitle) {
    return t('Поставщики автотоваров {cityTitle}. Адреса, телефоны компаний на Автобазаре', {
      ...data,
      cityTitle: t(regLocation) || t(location),
    });
  }

  if ((section === 'Сервисные центры' || section === 'Сервісні центри') && cityTitle) {
    return t(
      'Территориальные сервисные центры {cityTitle}. Адреса, телефоны ТСЦ для регистрации авто, оформления справок, замены водительского удостоверения',
      {
        ...data,
        cityTitle: t(regLocation) || t(location),
      },
    );
  }

  if (cityTitle) {
    return t(
      'Автосервисы {cityTitle} с адресами компаний, телефонами и картой проезда. Связаться с автосервисом и записаться на обслуживание можно на Автобазаре',
      {
        ...data,
        cityTitle: t(regLocation) || t(location),
      },
    );
  }

  return t(
    'Автомобильные организации в Украине: СТО ✅ Авторазборки ✅ Мойки ✅ Шиномонтаж и другие фирмы для владельцев авто',
  );
};

export const buildFirmPageSeoDescription = (
  title,
  tab,
  t,
  car_drive_countries = [],
  tags = [],
  firm,
) => {
  if (tab === 'blog') {
    return t('Актуальные новости и действующие акции компании {title} смотрите на Автобазаре', {
      title,
    });
  }

  const countries = Array.isArray(car_drive_countries)
    ? car_drive_countries.map(item => item.title).join(', ')
    : car_drive_countries;

  if (car_drive_countries.length > 0) {
    return t(
      'Компания {title} по доставке авто из {countries}. Условия выкупа с аукциона и пригона авто под ключ. Стоимость услуг и преимущества сотрудничества с компанией {title}',
      {
        title,
        countries,
      },
    );
  }

  if (Array.isArray(tags)) {
    for (let i = 0; i < tags.length; i++) {
      if (tags[i].slug && tags[i].slug === 'sto') {
        return t(
          'СТО {title}. Адрес, телефон, график работы, услуги СТО, последние новости и акции. Связаться с автосервисом и записаться на СТО можно на Автобазаре',
          {
            title,
            tags,
          },
        );
      }

      if (tags[i].slug && tags[i].slug === 'avtorazborka') {
        return t(
          'Авторазборка {title}. Компания по разбору авто. Адреса, телефоны, карта проезда, график работы, услуги компании, новости и акции смотрите на сайте Автобазар',
          {
            title,
          },
        );
      }

      if (tags[i].slug && tags[i].slug === 'avtovykup') {
        return t(
          '{title}. Услуги, новости, акции компании по выкупу авто. Адрес, телефоны, карта проезда и график работы смотрите на сайте Автобазар',
          {
            title,
          },
        );
      }

      if (tags[i].slug && tags[i].slug === 'avtotovary') {
        return t(
          'Поставщик автотоваров {title}. Адреса, телефоны, график работы компаний на Автобазаре. Самые актуальные предложения по автотоварам от компании',
          {
            title,
          },
        );
      }

      if (tags[i].slug && tags[i].slug === 'teritorialni-servisni-centri') {
        return t(
          '{title}. Адрес, телефон, график работы ТСЦ для регистрации авто, оформления справок, замены водительского удостоверения указаны на сайте Автобазар',
          {
            title,
          },
        );
      }
    }
  }

  return t('METATEGS_DESCRIPTION_FIRM_ZAPCHASTI', { title });
};

export const buildSearchAvtoSeoDescription = (data, t) => {
  const seoData = getSeoDataByParams(data, t);
  if (seoData && seoData.description) return seoData.description;

  const {
    make = '',
    model = '',
    location = '',
    generation = '',
    gearbox = '',
    engine = '',
    body = '',
    drive: driveSelected = '',
    isNew = false,
    makeTranslate = make,
    modelTranslate = model,
    year: yearSelected,
    country = null,
    city = null,
  } = data;

  const drive = buildDriveValue(driveSelected, t);
  const locale = t('locale');
  const inGenitiveLocation =
    location && sity[location]
      ? buildInGenitiveCityHeader(sity[location][locale].genitive)
      : (city &&
          city.title &&
          ` ${buildInGenitiveCityHeader(city[`${locale}_title`] || city.title)}`) ||
        `в ${sity['Украина'][locale].genitive}`;

  const yearVsSpace = yearSelected ? ` ${yearSelected} ${t('года')}` : '';
  const yearDotVsSpace = yearSelected ? ` ${yearSelected} ${t('г.')}` : '';
  const customGearboxAlt = gearbox in gearboxes ? gearboxes[gearbox][locale].altTitle : gearbox;
  const customGearbox = gearbox in gearboxes ? gearboxes[gearbox][locale].title : gearbox;
  const customEngineAlt = engine in engines ? engines[engine][locale].altTitle : engine;
  const customEngine = engine in engines ? engines[engine][locale].title : engine;
  const countryTitle = country && t(country.title);
  const countryFromTitle = country && country.from && country.from[locale];

  const params = {
    ...data,
    countryFromTitle,
    countryTitle,
    inGenitiveLocation,
    makeTranslate,
    modelTranslate,
    generation: generation ? ` ${generation}` : '',
    drive,
    year: yearVsSpace,
    yearDot: yearDotVsSpace,
  };

  // {locale}*/avto/{country}/
  if (country && !make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t('SEO_META_DESCRIPTION_AVTO_COUNTRY', { countryFromTitle });
  }

  if (make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t(
      isNew
        ? 'Купить легковой автомобиль {make}{year} 🚗 {inGenitiveLocation}. Большой выбор новых {makeTranslate}{yearDot} без посредников по выгодной цене на АвтоБазар.'
        : 'Продажа легковых автомобилей {make}{year} б/у 🚗 {inGenitiveLocation}. Удобный поиск по объявлениям поможет купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.',
      { ...params },
    );
  }
  if (make && model && !generation && !gearbox && !engine && !body && !drive) {
    return t(
      isNew
        ? 'Купить легковой автомобиль {make} {model}{year} 🚗 {inGenitiveLocation}. Большой выбор новых {makeTranslate}{yearDot} без посредников по выгодной цене на АвтоБазар.'
        : 'Продажа легковых автомобилей {make} {model}{year} б/у 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.',
      { ...params },
    );
  }
  if (make && model && body && !generation && !gearbox && !engine && !drive) {
    return t(
      isNew
        ? 'Купить {body} {make} {model}{year} 🚗 {inGenitiveLocation}. Выбрать новый {makeTranslate} {body}{yearDot} без посредников по выгодной цене на АвтоБазар.'
        : 'Продажа {body} {make} {model}{year} б/у 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.',
      { ...params },
    );
  }
  if (make && model && generation && !gearbox && !engine && !drive) {
    return t(
      isNew
        ? 'Купить {make} {model}{generation}{year} 🚗 {inGenitiveLocation}. Выбрать новый {makeTranslate}{yearDot} без посредников по выгодной цене на АвтоБазар.'
        : 'Продажа {make} {model}{generation}{year} б/у 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.',
      { ...params },
    );
  }
  if (make && model && gearbox && !engine && !drive) {
    return t(
      isNew
        ? 'Новые легковые автомобили {gearbox} {make} {model}{generation}{year} 🚗 {inGenitiveLocation}. Удобный поиск по предложениям поможет купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.'
        : 'Продажа легковых автомобилей {make} {model}{generation} {gearbox}{year} 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.',
      { ...params },
    );
  }
  if (make && model && gearbox && drive && !engine) {
    return t(
      isNew
        ? 'Купить новый легковой автомобиль {make} {model}{generation} {gearbox} {drive}{year} 🚗 {inGenitiveLocation}. Удобный поиск предложений продажи {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.'
        : 'Продажа легковых автомобилей {make} {model}{generation} {gearbox} {drive}{year} 🚗. Подбор предложений {inGenitiveLocation} поможет купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.',
      { ...params },
    );
  }
  if (make && model && gearbox && drive && engine) {
    return t(
      isNew
        ? 'Купить легковой автомобиль 🚗 {make} {model} {engine} {gearbox} {drive}{generation}{year}. Предложения {inGenitiveLocation} по продаже {makeTranslate} {modelTranslate}{yearDot} по выгодной цене на АвтоБазар.'
        : 'Легковые автомобили 🚗б/у {make} {model}{generation} {engine} {gearbox} {drive}{year}. Предложения по продаже {makeTranslate}{yearDot} {inGenitiveLocation} по выгодной цене на АвтоБазар.',
      { ...params },
    );
  }
  if (!make && !model && !gearbox && !drive && engine && !body) {
    return t(
      isNew
        ? '{customEngineAlt} новые {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.'
        : '{customEngineAlt} б/у {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.',
      {
        ...params,
        customEngineAlt,
      },
    );
  }
  if (make && !model && gearbox && !drive && !engine && !body) {
    return t(
      isNew
        ? 'Продажа новых {make} {customGearboxAlt} {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.'
        : 'Продажа {make} {customGearboxAlt} б/у {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.',
      {
        ...params,
        customGearboxAlt,
      },
    );
  }
  if (!make && !model && !gearbox && !drive && !engine && body) {
    return t(
      isNew
        ? 'Продажа новых автомобилей {body} {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.'
        : 'Продажа автомобилей {body} б/у {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.',
      { ...params },
    );
  }
  if (make && !model && !gearbox && !drive && engine && !body) {
    return t(
      isNew
        ? 'Продажа {customEngineAlt} {makeTranslate}{year} 🚗 Найти новый {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.'
        : 'Продажа {customEngineAlt} {makeTranslate}{year} 🚗 Найти б/у {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.',
      {
        ...params,
        customEngineAlt,
        customEngine,
      },
    );
  }
  if (make && model && !gearbox && !drive && engine && !body) {
    return t(
      isNew
        ? 'Продажа {customEngineAlt} {makeTranslate} {model}{year} 🚗 Найти новый {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.'
        : 'Продажа {customEngineAlt} {makeTranslate} {model}{year} 🚗 Найти б/у {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.',
      {
        ...params,
        customEngineAlt,
        customEngine,
      },
    );
  }
  if (!make && !model && gearbox && !drive && !engine && !body) {
    return t(
      isNew
        ? 'Продажа новых автомобилей {customGearbox}{year} {inGenitiveLocation} 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™.'
        : 'Продажа автомобилей {customGearbox}{year} б/у {inGenitiveLocation} 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™.',
      {
        ...params,
        customGearbox,
      },
    );
  }
  if (make && !model && !gearbox && !drive && !engine && body) {
    return t(
      isNew
        ? 'Продажа новых {body} {make}{year} 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.'
        : 'Продажа {body} {make}{year} б/у 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.',
      {
        ...params,
        customGearbox,
      },
    );
  }
  return t(
    isNew
      ? 'Купить легковой автомобиль 🚗 {inGenitiveLocation}. Большой выбор авто без посредников по выгодной цене на АвтоБазар.'
      : 'Продажа легковых автомобилей б/у 🚗 {inGenitiveLocation}. Удобный поиск по объявлениям поможет купить авто по выгодной цене на АвтоБазар.',
    {
      inGenitiveLocation,
    },
  );
};

export const buildDealersSeoDescription = (data, slug, t) => {
  const {
    make = '',
    model = '',
    makeTranslate = make,
    modelTranslate = model,
    location: locationRu = '',
  } = data;
  const seoData = getSeoDataByParams(
    { ...data, transport: data.transport || slug },
    t,
    'avtosalony',
  );
  if (seoData && seoData.description) return seoData.description;

  const locale = t('locale');

  const cityHeader = locationRu && sity[locationRu] ? locationRu : 'Украина';
  const location = locationRu && t(locationRu);
  const accusativeCityHeader = sity[cityHeader][locale].accusative;
  const inGenitiveCityHeader = buildInGenitiveCityHeader(sity[cityHeader][locale].genitive);

  if (slug === 'avto') {
    if (location && !make && !model) {
      return t(
        'Лучшие предложения автосалонов {inGenitiveCityHeader} – скидки автодилеров на новые автомобили. Запишитесь на тестдрайв ✅ адреса и телефоны ☎️ на сайте  АвтоБазар™.',
        { location, inGenitiveCityHeader },
      );
    }
    if (make && !location && !model) {
      return t(
        'Надежная ✅ покупка {makeTranslate} в автосалонах {make} – запишитесь на тестдрайв. Адреса ☎️ телефоны автодилеров на сайте АвтоБазар™.',
        {
          make,
          makeTranslate,
        },
      );
    }
    if (make && location && !model) {
      return t(
        'Предложения автосалонов {makeTranslate} {inGenitiveCityHeader}  ✅ покупка {make} в автосалонах – запишитесь на тестдрайв. Адреса ☎️ телефоны автодилеров на сайте АвтоБазар™.',
        {
          make,
          makeTranslate,
          inGenitiveCityHeader,
        },
      );
    }
    if (make && model && !location) {
      return t(
        'Предложения автосалонов {make} {model} ✅ купить {makeTranslate} {modelTranslate}  у автодилеров – запишитесь на тестдрайв. Адреса и ☎️ телефоны на сайте АвтоБазар™.',
        {
          make,
          model,
          makeTranslate,
          modelTranslate,
        },
      );
    }
    if (make && model && location) {
      return t(
        'Предложения автосалонов {accusativeCityHeader} на {make} {model} ✅ покупка {makeTranslate} {modelTranslate} у автодилера {inGenitiveCityHeader}. Адреса и ☎️ телефоны на сайте АвтоБазар™.',
        {
          make,
          model,
          makeTranslate,
          modelTranslate,
          accusativeCityHeader,
          inGenitiveCityHeader,
        },
      );
    }
  }
  if (slug === 'mototsikl') {
    if (location && !make) {
      return t(
        'Лучшие предложения на покупку мототехники в мотосалонах {inGenitiveCityHeader}. Мотоциклы, скутеры, квадроциклы, электробайки, мопеды и мотоэкипировка. Адреса и ☎️ на сайте АвтоБазар™.',
        { inGenitiveCityHeader },
      );
    }
    if (make && !location) {
      return t(
        'Лучшие цены на мототехнику {make} и акции мотосалонов. Мотоциклы, скутеры, квадроциклы, электробайки, мопеды  {makeTranslate} и мотоэкипировка. Адреса и ☎️ на сайте АвтоБазар™.',
        {
          make,
          makeTranslate,
        },
      );
    }
    if (make && location) {
      return t(
        'Лучшие цены на мототехнику {makeTranslate} и акции в мотосалонах {accusativeCityHeader}. Мотоцикли, скутери, квадроцикли, электробайки, мопеди {make} и мотоекипировка. Адреса и ☎️ на сайте АвтоБазар™.',
        {
          make,
          makeTranslate,
          accusativeCityHeader,
        },
      );
    }
    return t(
      'Каталог мотосалонов – лучшие цены мотомагазинов в вашем городе на мототехнику и с гарантией от салона. Сайт АвтоБазар™ ✅ адреса ☎️ телефоны.',
      {},
    );
  }
  if (slug === 'avtobus') {
    if (location && !make && !model) {
      return t(
        'Надежная ✅ покупка автобуса автосалонов {inGenitiveCityHeader} – запишитесь на тестдрайв буса. Адреса и ☎️ на АвтоБазар™',
        {
          inGenitiveCityHeader,
        },
      );
    }
    if (make && !location && !model) {
      return t(
        'Надежная ✅ покупка автобуса {makeTranslate} в автосалонах {make} – запишитесь на тестдрайв буса. Адреса и ☎️ на АвтоБазар™',
        {
          make,
          makeTranslate,
        },
      );
    }
    if (make && location) {
      return t(
        'Автобусы {makeTranslate} {inGenitiveCityHeader}  ✅ покупка буса {make} в салонах {accusativeCityHeader}. Адреса и ☎️ на АвтоБазар™',
        {
          make,
          makeTranslate,
          inGenitiveCityHeader,
          accusativeCityHeader,
        },
      );
    }
    return t(
      'Дилеры автобусов Украины – выберите автодилера в своем городе. Бус с гарантией от салона. Сайт АвтоБазар™ ✅ адреса ☎️ телефоны',
      {},
    );
  }
  if (slug === 'gruzovye') {
    if (location && !make && !model) {
      return t(
        'Надежная ✅ покупка грузовых автомобилей в автосалонах {accusativeCityHeader} – запишитесь на тестдрайв грузовика. Адреса и ☎️ на АвтоБазар™',
        { accusativeCityHeader },
      );
    }
    if (make && !location && !model) {
      return t(
        'Надежная ✅ покупка грузового {makeTranslate} в официальных автосалонах {make} – кредит, лизинг. Адреса и ☎️ на АвтоБазар™',
        {
          make,
          makeTranslate,
        },
      );
    }
    if (make && location) {
      return t(
        'Грузовик {makeTranslate} {inGenitiveCityHeader} ✅ покупка грузового {make} в салонах {accusativeCityHeader}. Адреса и ☎️ на АвтоБазар™',
        {
          make,
          makeTranslate,
          inGenitiveCityHeader,
          accusativeCityHeader,
        },
      );
    }
    return t(
      'Автосалоны грузовиков Украины – выберите автодилера в своем городе. Грузовой автомобиль с гарантией от салона. Сайт АвтоБазар™ ✅ адреса ☎️ телефоны салонов',
      {},
    );
  }
  if (slug === 'spetstehnika') {
    if (make && !location) {
      return t(
        'Продажа спецтехники {make} и услуги от официальных и проверенных дилеров Украины. Актуальные предложения, цены и акции на технику – АвтоБазар™',
        {
          make,
          makeTranslate,
        },
      );
    }
    if (location && !make) {
      return t(
        'Продажа спецтехники и услуги от официальных и проверенных дилеров {inGenitiveCityHeader}. Актуальные предложения, цены и акции на технику – АвтоБазар™',
        { inGenitiveCityHeader },
      );
    }
    return t(
      'Продажа спецтехники и услуги от официальных и проверенных дилеров Украины. Актуальные предложения, цены и акции на технику – АвтоБазар™',
      {},
    );
  }
  if (slug === 'vodnyi-transport') {
    if (make && !location) {
      return t(
        'Продажа водного транспорта {make} и услуги от официальных и проверенных салонов Украины. Актуальные предложения, цены и акции – АвтоБазар™',
        {
          make,
          makeTranslate,
        },
      );
    }
    if (location && !make) {
      return t(
        'Продажа водного транспорта и услуги от официальных и проверенных салонов {inGenitiveCityHeader}. Актуальные предложения, цены и акции – АвтоБазар™',
        { inGenitiveCityHeader },
      );
    }
    return t(
      'Продажа водного транспорта и услуги от официальных и проверенных салонов Украины. Актуальные предложения, цены и акции – АвтоБазар™',
      {},
    );
  }
  if (slug === 'pritsepy') {
    if (make && !location) {
      return t(
        'Продажа прицепов {make} и услуги от надежных компаний Украины. Актуальные предложения, цены и акции – АвтоБазар™',
        {
          make,
          makeTranslate,
        },
      );
    }
    if (location && !make) {
      return t(
        'Продажа прицепов и услуги от надежных компаний {inGenitiveCityHeader}. Актуальные предложения, цены и акции – АвтоБазар™',
        { inGenitiveCityHeader },
      );
    }
    return t(
      'Продажа прицепов и услуги от надежных компаний Украины. Актуальные предложения, цены и акции – АвтоБазар™',
      {},
    );
  }

  return t(
    'Все автосалоны Украины – актуальные цены и скидки на новые авто ✅ адреса и телефоны дилеров ☎️ каталог АвтоБазар™.',
    {},
  );
};

export const buildSparePartsSeoDescription = (data, rubricSlug, t, isRegion) => {
  const {
    location: locationRu = '',
    make = '',
    model = '',
    transport: selectedTransport,
    rubric: rubricTitle,
    partType: partTypeRu,
    partTypeUk,
  } = data;
  const seoData = getSeoDataByParams(data, t, 'zapchasti');
  if (seoData && seoData.description) {
    return seoData.description;
  }
  const locale = t('locale');

  const cityHeader = locationRu && sity[locationRu] ? locationRu : 'Украина';
  const location = locationRu && t(locationRu);
  const inGenitiveCityHeader = buildInGenitiveCityHeader(sity[cityHeader][locale].genitive);

  let rubric = rubricTitle;
  let partType = partTypeRu;
  const transport = replaceTransport(selectedTransport);

  let inCityOrRegion = `${t('в городе')} ${t(location)}`;
  if (isRegion && locationRu) {
    inCityOrRegion = `в ${sity[locationRu][locale].genitive}`;
  }

  if (locale === 'uk' && partTypeUk) partType = partTypeUk;

  if (!location && !rubric && !partType && !rubricSlug) {
    if (make && !model && !location) {
      return t(
        'Продажа запчастей на {make} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти на {transport} по выгодной цене.',
        {
          make,
          transport,
        },
      );
    }
    if (make && model) {
      return t(
        'Продажа автозапчастей на {make} {model} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти на {transport} по выгодной цене.',
        {
          make,
          model,
          transport,
        },
      );
    }
  }
  if (location && !rubric && !partType && !rubricSlug) {
    if (!make && !model) {
      return t(
        'Продажа запчастей на {transport} {inGenitiveCityHeader} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро найти автозапчасти на {transport} по лучшей цене {inCityOrRegion}.',
        {
          transport,
          inGenitiveCityHeader,
          inCityOrRegion,
        },
      );
    }
    if (make && !model) {
      return t(
        'Продажа автозапчастей {make} на {transport} {inGenitiveCityHeader} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти для {make}.',
        {
          make,
          transport,
          inGenitiveCityHeader,
          location,
        },
      );
    }
    if (make && model) {
      return t(
        'Продажа автозапчастей на {make} {model} {inCityOrRegion} ✅ Сравните цены и купите запчасти на {transport} по лучшей цене на АвтоБазар™.',
        {
          make,
          model,
          transport,
          inCityOrRegion,
        },
      );
    }
  }

  if (FIRST_RUBRICS_TYPES.includes(rubricSlug)) {
    rubric = rubric && rubrics[rubric][locale].accusative;
  } else if (SECOND_RUBRICS_TYPES.includes(rubricSlug)) {
    rubric = rubric && rubrics[rubric][locale].nominative;
  }

  /* ______________________FIRST TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && FIRST_RUBRICS_TYPES.includes(rubricSlug)) {
    if (make && !model) {
      return t(
        'Продажа автозапчастей {rubric} на {transport} {make} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям в Украине.',
        {
          rubric,
          make,
          transport,
        },
      );
    }
    if (make && model) {
      return t(
        'Продажа автозапчастей {rubric} на {make} {model} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям в Украине.',
        {
          rubric,
          make,
          model,
        },
      );
    }

    return t(
      'Продажа автозапчастей {rubric} на {transport} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям – сравните предложения в Украине.',
      {
        rubric,
        transport,
      },
    );
  }

  if (location && rubricSlug && rubric && !partType && FIRST_RUBRICS_TYPES.includes(rubricSlug)) {
    if (make && !model) {
      return t(
        'Продажа автозапчастей {rubric} на {transport} {make} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям {inGenitiveCityHeader}.',
        {
          rubric,
          make,
          transport,
          inGenitiveCityHeader,
        },
      );
    }
    if (make && model) {
      return t(
        'Продажа автозапчастей {rubric} на {transport} {make} {model} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям {inGenitiveCityHeader}.',
        {
          rubric,
          make,
          model,
          transport,
          inGenitiveCityHeader,
        },
      );
    }

    return t(
      'Продажа автозапчастей {rubric} на {transport} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям {inGenitiveCityHeader}.',
      {
        rubric,
        transport,
        inGenitiveCityHeader,
      },
    );
  }

  /* ______________________FIRST TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && FIRST_RUBRICS_TYPES.includes(rubricSlug)) {
    partType = replaceToUpperCase(partType);
    if (make && !model) {
      return t(
        '{partType} на {transport} {make} по выгодной цене на сайте АвтоБазар™ ✅ Большой выбор автозапчастей {rubric}.',
        {
          rubric,
          partType,
          transport,
          make,
        },
      );
    }
    if (make && model) {
      return t(
        '{partType} на {transport} {make} {model} по выгодной цене на АвтоБазар™ ✅ Большой выбор автозапчастей для {rubric}.',
        {
          rubric,
          partType,
          make,
          model,
          transport,
        },
      );
    }

    return t(
      '{partType} на {transport} по выгодной цене на сайте АвтоБазар™ ✅ Большой выбор автозапчастей {rubric}.',
      {
        rubric,
        partType,
        transport,
      },
    );
  }

  if (location && rubricSlug && rubric && partType && FIRST_RUBRICS_TYPES.includes(rubricSlug)) {
    partType = replaceToUpperCase(partType);

    if (make && !model) {
      return t(
        '{partType} на {transport} {make} по выгодной цене {inGenitiveCityHeader} ✅ Большой выбор запчастей для {rubric} – АвтоБазар™.',
        {
          rubric,
          partType,
          make,
          transport,
          inGenitiveCityHeader,
        },
      );
    }
    if (make && model) {
      return t(
        '{partType} на {make} {model} по выгодной цене {inGenitiveCityHeader} ✅ Большой выбор запчастей для {rubric} – АвтоБазар™.',
        {
          rubric,
          partType,
          make,
          model,
          inGenitiveCityHeader,
        },
      );
    }

    return t(
      '{partType} на {transport} по выгодной цене {inGenitiveCityHeader} ✅ Большой выбор автозапчастей для {rubric} – АвтоБазар™.',
      {
        rubric,
        partType,
        transport,
        inGenitiveCityHeader,
      },
    );
  }

  /* ______________________SECOND TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && SECOND_RUBRICS_TYPES.includes(rubricSlug)) {
    if (make && !model) {
      return t(
        '{rubric} по выгодной цене на {transport} {make} ✅ Найдите нужную деталь в Украине на АвтоБазар™.',
        {
          rubric,
          make,
          transport,
        },
      );
    }
    if (make && model) {
      return t(
        '{rubric} по лучшей цене на {transport} {make} {model} ✅ Найдите нужную деталь в Украине на АвтоБазар™.',
        {
          rubric,
          make,
          model,
          transport,
        },
      );
    }

    return t(
      '{rubric} по выгодной цене на {transport} ✅ Найдите нужную деталь в Украине на АвтоБазар™.',
      {
        rubric,
        transport,
      },
    );
  }

  if (location && rubricSlug && rubric && !partType && SECOND_RUBRICS_TYPES.includes(rubricSlug)) {
    if (make && !model) {
      return t(
        '{rubric} по выгодной цене на {transport} {make} ✅ Найдите нужную деталь {inGenitiveCityHeader} на АвтоБазар™.',
        {
          rubric,
          make,
          transport,
          inGenitiveCityHeader,
        },
      );
    }
    if (make && model) {
      return t(
        '{rubric} по выгодной цене на {transport} {make} {model} ✅ Найдите нужную деталь {inGenitiveCityHeader} на АвтоБазар™.',
        {
          rubric,
          make,
          model,
          transport,
          inGenitiveCityHeader,
        },
      );
    }

    return t(
      '{rubric} по выгодной цене на {transport} ✅ Найдите нужную деталь {inGenitiveCityHeader} на АвтоБазар™.',
      {
        rubric,
        transport,
        inGenitiveCityHeader,
      },
    );
  }

  /* ______________________SECOND TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && SECOND_RUBRICS_TYPES.includes(rubricSlug)) {
    partType = replaceToUpperCase(partType);
    if (make && !model) {
      return t(
        '{partType} на {transport} {make} по выгодной цене на сайте АвтоБазар™ ✅ {rubric} – большой выбор запчастей.',
        {
          rubric,
          partType,
          transport,
          make,
        },
      );
    }
    if (make && model) {
      return t(
        '{partType} на {transport} {make} {model} по выгодной цене на сайте АвтоБазар™ ✅ {rubric} – большой выбор запчастей.',
        {
          rubric,
          partType,
          make,
          model,
          transport,
        },
      );
    }

    return t(
      '{partType} на {transport} по выгодной цене на сайте АвтоБазар™ ✅ {rubric} – большой выбор запчастей.',
      {
        rubric,
        partType,
        transport,
      },
    );
  }

  if (location && rubricSlug && rubric && partType && SECOND_RUBRICS_TYPES.includes(rubricSlug)) {
    partType = replaceToUpperCase(partType);

    if (make && !model) {
      return t(
        'Выбирайте {partType} на {transport} {make} по выгодной цене {inGenitiveCityHeader} ✅ {rubric} на АвтоБазар™.',
        {
          rubric,
          partType,
          make,
          inGenitiveCityHeader,
          transport,
        },
      );
    }
    if (make && model) {
      return t(
        'Выбирайте {partType} на {transport} {make} {model} по выгодной цене {inGenitiveCityHeader} ✅ {rubric} на сайте АвтоБазар™.',
        {
          rubric,
          partType,
          make,
          model,
          transport,
          inGenitiveCityHeader,
        },
      );
    }

    return t(
      'Выбирайте {partType} на {transport} по выгодной цене {inGenitiveCityHeader} ✅ {rubric} на АвтоБазар™.',
      {
        rubric,
        partType,
        transport,
        inGenitiveCityHeader,
      },
    );
  }

  return t(
    'Продажа автозапчастей на {transport} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти на {transport} по выгодной цене.',
    {
      transport,
    },
  );
};

export const buildSearchMotoSeoDescription = (data, t) => {
  const seoData = getSeoDataByParams(data, t);
  if (seoData && seoData.description) return seoData.description;

  const { category, type, make, model, location, motoTitle, yearTitle } = data;
  const condition = t('бу и новой');
  const icon = '🏍️';
  const transportWho = t('мототехники');
  const transportWhat = t('мототранспорт');
  return [
    t('Продажа'),
    condition,
    category || type || motoTitle
      ? `${motoTitle || (type && type.title ? type.title.toLowerCase() : '')} ${category &&
        category.title
          ? category.title.toLowerCase()
          : ''}`
      : transportWho,
    icon,
    make && make.title,
    model && model.title,
    `${location || t('в Украине')}.`,
    t('Удобный поиск по объявлениям поможет Вам быстро и легко купить'),
    category || type
      ? `${type && type.title ? type.title.toLowerCase() : ''} ${category && category.title
          ? category.title.toLowerCase()
          : ''}`
      : transportWhat || '',
    `${yearTitle || ''}${t('по выгодной цене на Автобазаре™.')}`,
  ]
    .filter(i => !!i)
    .join(' ');
};

export const buildSearchCommercialSeoDescription = (data, t) => {
  const seoData = getSeoDataByParams(data, t, 'commercial');
  if (seoData && seoData.description) return seoData.description;

  const isUkraine = ['Україні', 'Украине'].includes(data.cityDescriptions);

  if (!isUkraine) {
    // eslint-disable-next-line no-param-reassign
    data.cityDescriptions = `${t('в')} ${t(data.cityDescriptions)}`;
    // eslint-disable-next-line no-param-reassign
  } else data.cityDescriptions = `в ${t('Украине')}`;

  const {
    transportDescriptions,
    transportNextDescriptions,
    transportCategoryTitle,
    make,
    model,
    isNew,
    transportType,
  } = data;

  if (transportType === 'avtobus' && transportCategoryTitle) {
    return t(
      'Купить бу и новые {transportCategoryTitle} автобусы {cityDescriptions}. Удобный поиск объявлений - сравните предложения и покупайте автобусы по лучшей цене на АвтоБазар™.',
      data,
    );
  }
  if (transportType === 'moto' && transportCategoryTitle) {
    return t(
      'Купить бу мототехнику {cityDescriptions} 🏍️ Объявления о продаже мотоциклов, скутеров, мопедов по лучшей цене на АвтоБазар™.',
      data,
    );
  }
  if (transportType === 'pritsepy' && transportCategoryTitle) {
    return t(
      'Купить бу или новый {transportCategoryTitle} {cityDescriptions} 🏍️ Объявления о продаже прицепного оборудования по лучшей цене на АвтоБазар™.',
      data,
    );
  }
  if (transportType === 'spetstehnika' && transportCategoryTitle) {
    return t(
      '{transportCategoryTitle} по лучшей цене купить на АвтоБазар™. Все объявления о продаже бу или новой спецтехники {cityDescriptions}.',
      data,
    );
  }
  if (transportType === 'vodnyi-transport' && transportCategoryTitle) {
    return t(
      'Купить {transportHeader} по лучшей цене {cityDescriptions}. Все объявления о продаже спецтехники на АвтоБазар™.',
      data,
    );
  }
  if (transportDescriptions && transportType === 'avtobus' && make) {
    return t(
      'Купить бу или новый автобус {makeTranslit} {cityDescriptions}. Удобный поиск объявлений - сравните предложения и покупайте автобусы {make} по лучшей цене на АвтоБазар™.',
      data,
    );
  }
  if (transportDescriptions && make && !model && isNew) {
    return t(
      'Купить новые {transportDescriptions} {make} 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {makeTranslit} {yearDescriptions}по выгодной цене на Автобазаре',
      {
        ...data,
        transportDescriptions: replaceToLowerCase(transportDescriptions),
        transportNextDescriptions: replaceToLowerCase(transportNextDescriptions),
      },
    );
  }
  if (transportDescriptions && make && model && !isNew) {
    return t(
      'Купить {transportDescriptions} {make} {model} бу 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {makeTranslit} {modelTranslit} {yearDescriptions}по выгодной цене на Автобазаре',
      {
        ...data,
        transportDescriptions: replaceToLowerCase(transportDescriptions),
        transportNextDescriptions: replaceToLowerCase(transportNextDescriptions),
      },
    );
  }
  if (transportDescriptions && make && !model && !isNew) {
    return t(
      'Купить {transportDescriptions} {make} бу 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {makeTranslit} {yearDescriptions}по выгодной цене на Автобазаре',
      {
        ...data,
        transportDescriptions: replaceToLowerCase(transportDescriptions),
        transportNextDescriptions: replaceToLowerCase(transportNextDescriptions),
      },
    );
  }
  if (transportDescriptions && !make && !model && isNew) {
    return t(
      'Купить новые {transportDescriptions} 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {yearDescriptions}по выгодной цене на Автобазаре',
      {
        ...data,
        transportDescriptions: replaceToLowerCase(transportDescriptions),
        transportNextDescriptions: replaceToLowerCase(transportNextDescriptions),
      },
    );
  }
  if (transportDescriptions && make && model && isNew) {
    return t(
      'Новые {transportDescriptions} {make} {model} 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {makeTranslit} {modelTranslit} {yearDescriptions}по выгодной цене на Автобазаре',
      {
        ...data,
        transportDescriptions: replaceToLowerCase(transportDescriptions),
        transportNextDescriptions: replaceToLowerCase(transportNextDescriptions),
      },
    );
  }
  if (transportDescriptions && make && model && !isNew) {
    return t(
      'Купить {transportDescriptions} {make} {model} бу 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {makeTranslit} {modelTranslit} {yearDescriptions}по выгодной цене на Автобазаре',
      {
        ...data,
        transportDescriptions: replaceToLowerCase(transportDescriptions),
        transportNextDescriptions: replaceToLowerCase(transportNextDescriptions),
      },
    );
  }
  if (transportDescriptions && make && !model && isNew) {
    return t(
      'Купить новые {transportDescriptions} {make} 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {makeTranslit} {yearDescriptions}по выгодной цене на Автобазаре',
      {
        ...data,
        transportDescriptions: replaceToLowerCase(transportDescriptions),
        transportNextDescriptions: replaceToLowerCase(transportNextDescriptions),
      },
    );
  }
  if (transportDescriptions && !make && !model && isNew) {
    if (transportType === 'gruzovye') {
      return t(
        'Купить новые {transportDescriptions} 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре',
        {
          ...data,
          transportDescriptions: replaceToLowerCase(transportDescriptions),
          transportNextDescriptions: replaceToLowerCase(transportNextDescriptions),
        },
      );
    }
    if (transportType === 'spetstehnika') {
      return t(
        'Купить новую {transportDescriptions} 🚜 {cityDescriptions}. {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре',
        {
          ...data,
          transportDescriptions: replaceToLowerCase(transportDescriptions),
          transportNextDescriptions: replaceToLowerCase(transportNextDescriptions),
        },
      );
    }
    return t(
      'Продажа новых {transportDescriptions} 🚛 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре',
      {
        ...data,
        transportDescriptions: replaceToLowerCase(transportDescriptions),
        transportNextDescriptions: replaceToLowerCase(transportNextDescriptions),
      },
    );
  }
  if (transportDescriptions && !make && !model && !isNew) {
    if (transportType === 'gruzovye') {
      return t(
        'Продажа {transportDescriptions} бу 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре™.',
        {
          ...data,
          transportDescriptions: replaceToLowerCase(transportDescriptions),
          transportNextDescriptions: replaceToLowerCase(transportNextDescriptions),
        },
      );
    }
    if (transportType === 'spetstehnika') {
      return t(
        'Купить {transportDescriptions} бу 🚜 {cityDescriptions}. {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре',
        {
          ...data,
          transportDescriptions: replaceToLowerCase(transportDescriptions),
          transportNextDescriptions: replaceToLowerCase(transportNextDescriptions),
        },
      );
    }
    return t(
      'Купить {transportDescriptions} бу 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {yearDescriptions}по выгодной цене на Автобазаре',
      {
        ...data,
        transportDescriptions: replaceToLowerCase(transportDescriptions),
        transportNextDescriptions: replaceToLowerCase(transportNextDescriptions),
      },
    );
  }
  return t(
    'Купить бу 🚚 в Украине. Удобный поиск по объявлениям поможет купить {yearDescriptions}по выгодной цене на Автобазаре',
  );
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoDescription.js